import { RadioGroup } from '@profgeosoft-ui/react';
import { observer } from 'mobx-react-lite';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import type { TWellListView } from 'src/api-types/wells.types';

import styles from './WellListWidget.module.scss';

type Props = {
  sorting: number;
  changeSorting: (sorting: number) => void;
  view: TWellListView;
};

export const WellSortingTooltip = observer<Props>(function WellSortingTooltip({ sorting, changeSorting, view }) {
  const sortingTooltipRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  const groups = view.sorting.sortItems.reduce<{ name: string; items: { value: number; label: string }[] }[]>(
    (acc, item, index) => {
      const groupNames = Array.isArray(item.group) ? item.group : [item.group];

      groupNames.forEach((groupName) => {
        let existingGroup = acc.find((group) => group.name === groupName);

        if (!existingGroup) {
          existingGroup = { name: groupName, items: [] };
          acc.push(existingGroup);
        }

        existingGroup.items.push({ value: index, label: t(`Labels:${item.name}`) });
      });

      return acc;
    },
    []
  );

  return (
    <div className={styles.sortingTooltip__Wrapper} ref={sortingTooltipRef}>
      {groups.map((group) => (
        <div key={group.name} className={styles.sortingTooltip__optionsContainer}>
          <div>{t(`Labels:${group.name}`)}:</div>
          <RadioGroup value={sorting} items={group.items} onChange={(value) => changeSorting(Number(value))} />
        </div>
      ))}
    </div>
  );
});
